import React from 'react';
import { Frame1MobileWrapper } from '../styles';

const loadJsHtml = '<script>if (window.googletag) {googletag.cmd.push(function () {googletag.display("rcsad_Frame1")})};</script>';

export const Frame1Mobile = () => (
  <Frame1MobileWrapper className="Frame1Mobile">
    <div className="adv-frame1">
      <div id="rcsad_Frame1" style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: loadJsHtml }} />
    </div>
  </Frame1MobileWrapper>
);

export const EVENT_FRAME1_NAME = 'McHubLiveChangeDay';
